/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_RecordingInputs */

const en_us2_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release to send`)
};

const pt_br2_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solte para enviar`)
};

const es_419_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta para enviar`)
};

const pt_pt2_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larga para enviar`)
};

const fr_fr2_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relâche pour envoyer`)
};

const de_de2_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslassen zum Senden`)
};

const it_it2_coach_mic_recording = /** @type {(inputs: Coach_Mic_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilascia per inviare`)
};

/**
* | output |
* | --- |
* | "Release to send" |
*
* @param {Coach_Mic_RecordingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_recording = /** @type {((inputs?: Coach_Mic_RecordingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_RecordingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_recording(inputs)
	if (locale === "es-419") return es_419_coach_mic_recording(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_recording(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_recording(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_recording(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_recording(inputs)
	return en_us2_coach_mic_recording(inputs)
});
export { coach_mic_recording as "coach-mic.recording" }